export default __webpack_public_path__ + "static/media/portfolio-default.662fd2dc.png";